























































































































































































import { IRoomControl } from "@/@types/hotel/room";
import { Component, Prop, Vue } from "vue-property-decorator";

import RoomControl from "@/components/administration/hotel/room/room-control.vue";
import RoomControlForm from "@/components/forms/room/room-control-form.vue";
import ButtonBack from "@/components/buttons/button-back.vue";
import HotelFaq from "@/components/administration/hotel/hotel-faq.vue";
import draggable from "vuedraggable";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    RoomControl,
    RoomControlForm,
    ButtonBack,
    HotelFaq,
    draggable,
  },
})
export default class RoomControlSettings extends Vue {
  @Prop({ type: Array, default: () => [] }) types!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) levels!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) statuses!: Array<IRoomControl>;
  @Prop({ type: String, default: "" }) control_id!: string;
  @Prop({ type: Boolean, default: false }) controlDeleted!: boolean;
  tabIndex = 0;
  enabled = true;
  dragging = false;

  get list(): Array<IRoomControl> {
    const list =
      this.tabIndex == 0
        ? this.statuses
        : this.tabIndex == 1
        ? this.types
        : this.levels;
    return list;
  }

  get item(): IRoomControl | null {
    const arr =
      this.tabIndex == 0
        ? this.statuses
        : this.tabIndex == 1
        ? this.types
        : this.levels;
    const st = arr.find((el) => el._id == this.control_id);
    if (st) return st;
    return null;
  }

  onSaveSorts(): void {
    for (let i = 0; i < this.list.length; i++) {
      const data: Partial<IRoomControl> = { sort_order: i };
      this.$emit("change", data, this.list[i]._id, this.tabIndex);
    }
    this.$bvModal.hide("subsequence");
  }

  change(data: Partial<IRoomControl>, id: string): void {
    this.$emit("change", data, id, this.tabIndex);
  }
}
